// extracted by css-extract-rspack-plugin
export default {"modalBody":"h0lNq","modalTextArea":"xMHru IDnFd STNQK O4m07"};